import React from "react";
import firebase from "../../constants/Firebase";
import UserTabsBrowse from "./UserTabsBrowse";
import "./user-browse.css";

class UserBrowse extends React.Component {
	// FETCH FIREBASE
	constructor(props) {
		super(props);
		this.state = {
			user: {},
		};
		this.fetchFirebase = this.fetchUserTabs.bind(this);
	}

	// FOCUS IN MODAL
	componentDidMount() {
		this.fetchUserTabs();
	}

	// FETCH GET TAB FIREBASE
	async fetchUserTabs() {
		const requestOptions = {
			method: "GET",
			redirect: "follow",
		};

		await fetch(
			`${firebase.databaseURL}/users/${this.props.match.params.userID}.json`,
			requestOptions
		)
			// PARSE JSON HTTP RESPONSE TO TRANSFORM INTO JS OBJECT
			.then((response) => response.json())
			.then((result) => {
				// TAB SET STATE
				this.setState({
					user: result ? result : {},
				});
			})
			.catch((error) => console.log("error:", error));
	}

	render() {
		return (
			<>
				{/* MAIN TABS COMPONENT */}
				<UserTabsBrowse user={this.state.user}/>
			</>
		);
	}
}

export default UserBrowse;
